import { render, staticRenderFns } from "./AddProject.vue?vue&type=template&id=1966f3b7&scoped=true&"
import script from "./AddProject.vue?vue&type=script&lang=js&"
export * from "./AddProject.vue?vue&type=script&lang=js&"
import style0 from "./AddProject.vue?vue&type=style&index=0&id=1966f3b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1966f3b7",
  null
  
)

component.options.__file = "AddProject.vue"
export default component.exports